import WINDOW from "../../../utils/window";

/**
 *
 * @param {MainClassProps} main
 * @param {EventListProps} event
 * @param {ListenerDetailsProps} details
 */
const addGlobalListener = (main, event, details) => {
  /**
   * Custom listener callback function
   * @param {CustomEventProps} e
   */
  const callback = (e) => {
    e.details = details;
    return main.on.get(event)?.(e);
  };

  const globalEvent = /** @type {"pointer" | "scroll"} */ (event);
  const globalListeners = /** @type {WindowListenersProps} */ (
    WINDOW.get("listeners")
  );

  if (!globalListeners.get(globalEvent)) {
    window.addEventListener(event, callback);
    globalListeners.set(globalEvent, [callback, details]);
  }
};

export default addGlobalListener;
